import type { Space } from '@mail/cross-sizes-utils/types';
import { Icon20ErrorCircleOutline } from '@vkontakte/icons';
import { Spacing, Text } from '@vkontakte/vkui';
import React from 'react';

import styles from './TBankMobileBlock.css';

interface TBankMobileBlockProps {
    space: Space;
}

export const TBankWarning = () => {
    return (
        <div className={styles.warningTBank}>
            <Icon20ErrorCircleOutline fill={'var(--vkui--color_icon_accent)'} />
            <Text>Управлять подпиской можно в&nbsp;приложении Т-Банк</Text>
        </div>
    );
};

export const TBankMobileBlock = ({ space }: TBankMobileBlockProps) => {
    return (
        <div className={styles.root}>
            <Text className={styles.header}>{space?.value} на месяц</Text>
            <Spacing size={8} />
            <Text className={styles.subtitle}>Подписка активна</Text>
            <Spacing size={32} />
            <TBankWarning />
            <Spacing size={8} />
        </div>
    );
};
